<template>
  <div class="columns is-multiline is-marginless is-main-content is-paddingless"
       v-if="criteresRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 is-marginless overflow-auto hauteur-brief-filtre">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeTypeTaxationTlpe.filtres.actif.tilte')">
            <b-select v-model="criteresRecherche.actif">
              <option :value="null"></option>
              <option :value="true"> {{ $t('listeTypeTaxationTlpe.filtres.actif.yes') }}
              </option>
              <option :value="false"> {{ $t('listeTypeTaxationTlpe.filtres.actif.no') }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('general.button.appliquer')}}
      </button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('general.button.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import genererCritereRecherche from '@/services/parametrage/typeTaxationTlpe/genererCritereRechercheTypeTaxationTlpe';
import { SET_CRITERE } from '@/store/modules/typeTaxationTlpe-mutation-type';

const TypeTaxationTlpe = createNamespacedHelpers('typeTaxationTlpe');

export default {
  data() {
    return {
      criteresRecherche: null,
    };
  },
  computed: {
    ...TypeTaxationTlpe.mapGetters({
      criteresRechercheFromStore: 'criteresRecherche',
    }),
  },
  methods: {
    ...TypeTaxationTlpe.mapMutations({
      setCriteresRecherche: SET_CRITERE,
    }),
    viderCritere() {
      this.criteresRecherche = genererCritereRecherche();
    },
    appliquerCritere() {
      this.setCriteresRecherche(this.criteresRecherche);
      this.$emit('recherche');
    },
    initializeFiltre() {
      this.criteresRecherche = cloneDeep(this.criteresRechercheFromStore);
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
